var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9712 29.4994C65.0079 49.1149 49.1061 65.0167 29.4906 30.98C9.87508 65.0167 -6.02679 49.1149 28.0099 29.4994C-6.02679 9.88387 9.87508 -6.018 29.4906 28.0187C49.1078 -6.01629 65.0096 9.88387 30.9712 29.4994Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5465 30.5465C40.7441 68.4845 18.2559 68.4845 28.4535 30.5465C-9.48449 40.7441 -9.48449 18.2559 28.4535 28.4535C18.2559 -9.48449 40.7441 -9.48449 30.5465 28.4535C68.4845 18.2559 68.4845 40.7441 30.5465 30.5465Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.64b95c0b54303b73b887e56461343644.svg";
export { ForwardRef as ReactComponent };